import styled from "styled-components";

export const StickerView = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${({ theme }) => theme.spacing.xxx_small }px;
  border-radius: ${({ theme }) => theme.border_radius.medium }px;
  overflow: hidden;

  & > div.sticker-frame {
    display: flex;
    align-items: center;
    justify-content: center;
    width: fit-content;
    max-width: 180px;
    min-width: 72px;
    min-height: 72px;
    overflow: hidden;
  }

  & > div.sticker-frame > img {
    display: block;
    max-width: 180px;
    max-height: 180px;
    object-fit: contain;
  }

  & > div.sticker-frame > span {
    padding: ${({ theme }) => `${ theme.spacing.xx_small }px ${ theme.spacing.x_small }px`};
    border-radius: ${({ theme }) => theme.border_radius.small }px;
    background-color: ${({ theme }) => theme.colors.text.default }11;
    color: ${({ theme }) => theme.colors.text.default };
  }
`;
